import {
  PaymentMethod,
  PaymentMethodText,
} from 'domains/models/event_payment/payment_method';
import { z } from 'zod';

export const PaymentMethodEnum = z.nativeEnum(PaymentMethod);
export const PaymentMethodTextEnum = z.nativeEnum(PaymentMethodText);
